import { Dialog } from "construct-ui";
import moment from "moment";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import DatePickerComponent from '../../../components/date-picker/date-picker.component';
import { getRandomPingList, exportExcel } from "../../../models/announcement/randomPing.model";
import ViewBase from "../../view-base.view";
import codeMasterModel from "../../../models/common/code-master.model";
import AddRandomPingDialog from "./randomPing-add.dialog";
// import RecipentDialog from "./randomPing-recipent-list.dialog";
import DetailDialog from "./randomPing-detail.dialog"
import { formats as FORMATS } from "../../../config/constants";

/**
 * RandomPing View
 * @author Molly Liu
 */

export default function RandomPingView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = {
    fromDate: moment().add(-3, 'month').format(FORMATS.dateFormat),
    toDate: moment().format(FORMATS.dateFormat),
    title: '',
    pingType: {}
  };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let currentSearchParams = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let isAddRandomPingOpen = false;
  // let isRecipentDialogOpen = false;
  let isDetailDialogOpen = false;

  let pingList = [];
  let pingTypes = [];
  let selectedRandomPingID = "";

  const toQueryParams = (params) => {
    return Object.assign(
      {
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
        fromDate: moment(params.fromDate).format(FORMATS.apiDateFormat),
        toDate: moment(params.toDate).format(FORMATS.apiDateFormat),
        title: params.title,
        pingType: params.pingType.name
      }
    );
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    pagination = structuredClone(DEFAULT_PAGINATION);
    currentSearchParams = structuredClone(filters)
    getData();
  }

  const getData = () => {
    this.showLoading();
    getRandomPingList(toQueryParams(currentSearchParams))
      .then((result) => {
        if (result.data) {
          pingList = result.data;
          pagination.pageIndex = result.pageIndex;
          pagination.pageSize = result.pageSize;
          pagination.totalItems = result.total;
        }
        this.hideLoading();
      })
      .catch((error) => {
        this.hideLoading();
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const downloadRandomPing = () => {
    this.showLoading();
    currentSearchParams = structuredClone(filters)
    const filter = toQueryParams(currentSearchParams)

    const params = {
      sortBy: "",
      orderBy: "",
      pageIndex: 0,
      pageSize: 0,
      storedProcedureCode: "81",
      params: [
        { code: "8", value: filter.fromDate },
        { code: "9", value: filter.toDate },
        { code: "13", value: filter.title },
        { code: "2", value: "" }, 
        { code: "3", value: "0" }, 
        { code: "4", value: "0" }
      ],
      excelSheetNames: ["Random Ping List"]
    };
    const FILE_NAME = `Random-Ping-List-${moment(new Date()).format(FORMATS.apiDateFormat)}.xlsx`
    exportExcel(params, FILE_NAME)
      .catch((error => {
        this.handleError(error);
      }))
      .finally(() => {
        this.hideLoading();
      })
  }

  const getPingTypes = () => {
    codeMasterModel.getByCategoryV2({ category: 'PingType' })
      .then(result => {
        pingTypes = result;
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    pagination = structuredClone(DEFAULT_PAGINATION);
  }

  const openRandomPingAddModal = () => {
    isAddRandomPingOpen = true;
  }

  const closeRandomPingUploadModal = () => {
    isAddRandomPingOpen = false;
  }

  const onSaveComplete = () => {
    isAddRandomPingOpen = false;
    getData();
  }

  const openDialog = (key, randomPingHeaderID) => {
    selectedRandomPingID = randomPingHeaderID;
    if (key === 'Detail') {
      isDetailDialogOpen = true;
    } 
    // else {
    //   isRecipentDialogOpen = true;
    // }
  }

  // const closeRecipentDialog = () => {
  //   isRecipentDialogOpen = false;
  // }

  const closeDetailDialog = () => {
    isDetailDialogOpen = false;
  }

  return {
    oninit: () => {
      getData();
      getPingTypes();
    },
    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m('.card-body',
            m('form.needs-validation[novalidate].row.g-2', { onsubmit: handleFormSubmit },
              m(".col-md-3.col-lg-3.position-relative",
                m('label.form-label', this.getText("LT00000070", "Date Range")),
                m(DatePickerComponent, {
                  class: 'form-control',
                  isRange: true,
                  dateStart: filters.fromDate, // default date range
                  dateEnd: filters.toDate, // default date range
                  onselect: (e) => {
                    filters.fromDate = moment(e.detail.start).format(FORMATS.dateFormat);
                    filters.toDate = moment(e.detail.end).format(FORMATS.dateFormat);
                  }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="fixtureNameInput"]', this.getText("LT00000037", "Title")),
                m('input#fixtureNameInput', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText("LT00000037", "Title"),
                  type: 'text',
                  maxlength: 200,
                  value: filters.title,
                  onchange: (e) => { filters.title = e.target.value }
                })
              ),
              m(".col-md-3.col-lg-3.position-relative",
              m("label.form-label[for='pingType']",
                this.getText("LT00008153", "Ping Type")
              ),
              m(SingleSelectComponent, {
                id: "pingType",
                items: pingTypes,
                allowEmpty: false,
                required: true,
                filterable: false,
                selectedItem: filters.pingType,
                onSelect: (s) => {
                  filters.pingType = s;
                }
              })
            ),
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary[type="submit"]', this.getText("LT00000001", "Search")),
                m('button.btn.btn-white',
                  {
                    onclick: () => {
                      clearFilter();
                    }
                  },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.row.g-2',
              m('.col-12.d-flex.justify-content-end',
                m('button.btn.btn-success.me-2', {
                  onclick: openRandomPingAddModal,
                }, m('i.bi.bi-plus-circle'),
                  this.getText('LT00000090', 'Add')),

                m('button.btn.btn-primary', {
                  onclick: downloadRandomPing,
                  disabled: pingList.length === 0
                }, m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00000018', 'Excel Download'))
              ),
              m('.col-12',
                m('.table-responsive',
                  m('table.table.table-sm',
                    m('thead',
                      m('tr.align-middle.center',
                        m('th', this.getText("LT00000037", "Title")),
                        m('th', this.getText("LT00000038", "Sender")),
                        m('th', this.getText("LT00000039", "Recipients")),
                        m('th', this.getText("LT00008150", "Verified")),
                        m('th', this.getText("LT00008151", "Unverified")),
                        m('th', this.getText("LT00000424", "Rejected")),
                        m('th', this.getText("LT00008152", "No Response")),
                        m('th', this.getText("LT00000041", "Create Date")),
                        m('th', this.getText("LT00008153", "Ping Type")),
                        m('th', this.getText('LT00000015', 'Status'))
                      )
                    ),
                    m('tbody',
                      pingList?.length === 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td",
                          { colspan: "100%" },
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      pingList?.length > 0 &&
                      pingList.map((item) => {
                        return m('tr.align-middle.center',
                          m('td', m('button.btn.btn-link', {
                            onclick: () => { openDialog("Detail", item.randomPingHeaderID) } 
                          }, item.title)),
                          m('td', m('span.cursor-text', item.sender)),
                          m('td', m('span.cursor-text', item.recipients)),
                          m('td', m('span.cursor-text', item.verifiedCount)),
                          m('td', m('span.cursor-text', item.unverifiedCount)),
                          m('td', m('span.cursor-text', item.rejectCount)),
                          m('td', m('span.cursor-text', item.noResponseCount)),
                          m('td', m('span.cursor-text', moment(item.createDate).format('YYYY-MM-DD HH:mm:ss'))),
                          m('td', m('span.cursor-text', item.pingType)),
                          m('td', item.status == "Complete" && m('.badge.rounded-pill.text-bg-success', item.status),
                            item.status == "Pending" && m('.badge.rounded-pill.text-bg-warning', item.status))
                        )
                      }))
                  )
                )
              )
            ),
            m('.col-12', m(paginationComponent,
              {
                currentPage: pagination.pageIndex,
                pageSize: pagination.pageSize,
                totalItems: pagination.totalItems,
                onPageChanged: (pageIndex) => {
                  pagination.pageIndex = pageIndex;
                  getData();
                },
                onPageSizeChanged: (_, pageSize) => {
                  pagination.pageIndex = DEFAULT_PAGINATION.pageIndex
                  pagination.pageSize = pageSize;
                  getData();
                }
              }
            ))
          )
        ),
        isAddRandomPingOpen &&
        m(Dialog, {
          isOpen: isAddRandomPingOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: closeRandomPingUploadModal,
          title: this.getText("LT00008155", "Add Random Ping"),
          content: m(AddRandomPingDialog, { onClose: closeRandomPingUploadModal, onSave: onSaveComplete }),
          "class": "cui-dialog",
        }),
        // isRecipentDialogOpen &&
        // m(Dialog, {
        //   isOpen: isRecipentDialogOpen,
        //   transitionDuration: 200,
        //   closeOnOutsideClick: false,
        //   onClose: closeRecipentDialog,
        //   title: this.getText("LT00000039", "Recipients"),
        //   content: m(RecipentDialog, { onClose: closeRecipentDialog, selectedRandomPingID: selectedRandomPingID }),
        //   "class": "cui-dialog",
        // }),
        isDetailDialogOpen &&
        m(Dialog, {
          isOpen: isDetailDialogOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: closeDetailDialog,
          title: this.getText("LT00000039", "Recipients"),
          content: m(DetailDialog, { onClose: closeDetailDialog, selectedRandomPingID: selectedRandomPingID }),
          "class": "cui-dialog-xxl",
        }),
        this.getBaseViews()
      ];
    }
  };
}
